import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    scorllTop:0,
    isLogin:()=>{
      if(localStorage.getItem('token')||sessionStorage.getItem('token')){
        return true
      }
     return false
    },uid:null,
    Auth_token:null,
    public_key:null,
    nonce:null,
    signature:null,
    userInfo:null,
    type:null
  },
  getters: {
  },
  mutations: {
    setType(state,it){
      state.type=it
    },
    
    setUserInfo(state,it){
      state.userInfo=it
    },
    setAuth_token(state,it){
      state.Auth_token=it
    },
    setPublic_keyLogin(state,it){
      state.public_key=it.public_key
      state.nonce=it.nonce
      state.signature=it.signature
    },
    setScorllTop(state,it){
      state.scorllTop=it
    },
    setUid(state,it){
      state.uid=it
    }
    
  },
  actions: {
  },
  modules: {
  }
})
